/* 倒入 api */
import axios from '@/utils/ajax/index';

/* 导出文件 api */
import fileExport from '@/utils/fileExport/index';

/* 按地区查询连锁诊所此账号下所有诊所信息 */
export const area = (params) => {
  return axios({
    url: '/chain/hospitals/area',
    method: 'get',
    params,
  });
};

/* 查询连锁诊所此账号下所有诊所信息 */
export const hospitals = (params) => {
  return axios({
    url: '/chain/hospitals',
    method: 'get',
    params,
  });
};

/* 经营统计详情 */
export const operations = (data) => {
  return axios({
    url: '/chain/hospitals/orderStatistic',
    method: 'post',
    data,
    timeout: 30000,
  });
};

/* 经营统计详情（折现图） */
export const chart = (data) => {
  return axios({
    url: '/chain/hospitals/orderStatistic',
    method: 'post',
    data,
    timeout: 30000,
  });
};

/* 药品销售详情 */
export const sales = (data) => {
  return axios({
    url: '/chain/hospitals/drugStatistic',
    method: 'post',
    data,
    timeout: 30000,
  });
};

/* 查询连锁诊所药品 */
export const searchDrugList = (data) => {
  return axios({
    url: '/chain/hospitals/searchDrugList',
    method: 'post',
    data,
    hideLoading: true,
  });
};

// 药品信息导出
export const drugExport = (params) => {
  const path = '/chain/hospitals/drugStatistic/excel';
  fileExport(path, params);
};


export default {
  area,
  hospitals,
  operations,
  chart,
  sales,
  searchDrugList,
  drugExport,
};
